import type { TagItem } from "./types";

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === "object" && value !== null;

const text = (value: unknown): string =>
  typeof value === "string" ? value.trim() : "";

export const getValidTags = (value: unknown): TagItem[] => {
  // No builder o campo chega como array cru ([{ id, ref }]); no renderer vem
  // coerced do índice do CMS como { tags: [...], labels: [...] }. Normaliza os dois.
  const list = Array.isArray(value)
    ? value
    : isRecord(value) && Array.isArray((value as { tags?: unknown }).tags)
      ? (value as { tags: unknown[] }).tags
      : [];

  return list
    .filter(isRecord)
    .map((raw, index): TagItem => {
      const ref = text(raw.ref);
      if (ref) return { id: text(raw.id) || ref, ref, label: "" };
      return {
        id: text(raw.id) || `tag-${index}`,
        label: text(raw.label) || text(raw.text),
        icon: text(raw.icon) || undefined,
        backgroundColor: text(raw.backgroundColor) || undefined,
        textColor: text(raw.textColor) || undefined,
      };
    })
    .filter((tag) => !!tag.ref || !!tag.label);
};

export const resolveTagRefs = (tags: TagItem[], registry: TagItem[] = []): TagItem[] =>
  tags.flatMap((tag) => {
    if (!tag.ref) return [tag];
    const badge = registry.find((candidate) => candidate.id === tag.ref);
    return badge && badge.label ? [{ ...badge, id: tag.id, ref: tag.ref }] : [];
  });
